




















































import {
  computed,
  defineComponent,
  onMounted,
  nextTick,
  toRefs,
  ref,
  watch,
  getCurrentInstance,
} from '@vue/composition-api';
import { BrowseIcon, DownloadIcon, ChartIcon, HelpIcon } from 'tdesign-icons-vue';
import { i18n_t } from '@/locales/i18n';

// 引入 compositions
import linkDownAndPreviewHandler from '@/renderer/components/linkList/compositions/linkDownAndPreviewHandler';

// 引入工具类
import { optAuth } from '@/renderer/scripts/composition/authHandler';
import { formatSize, getNameTipsDetail } from '@/renderer/scripts/utils/tools';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { SEARCH_TYPE_MAP } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import linkDetailHandler, { BaseDetailType, DetailType } from '../../linkList/compositions/linkDetailHandler';

function formatSizeString(itemSize?: string) {
  const { size, unit } = formatSize(itemSize as string);
  return `${size} ${unit}`;
}
export default defineComponent({
  name: 'linkDetail',
  props: {
    params: {
      required: true,
      type: Object as () => Drawer.LinkDetailParams<SMH.GetShareLinkData>,
    },
  },
  filters: {
    formatFileType(key: string) {
      const fileType: Record<string, string> = SEARCH_TYPE_MAP;
      return fileType[key] || key;
    },
  },
  components: {
    BrowseIcon,
    DownloadIcon,
    ChartIcon,
    HelpIcon,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    // 解构 props
    const { params } = toRefs(props);
    const selectedItem = computed(() => params.value.selectedItem);
    const userData = ref<SMH.UserBaseInfo | {}>({});
    const { methods: linkDownAndPreview } = linkDownAndPreviewHandler();
    const { methods: detailMethods, detailItem, loading } = linkDetailHandler();

    const getLinkData = async () => {
      try {
        await detailMethods.getLinkDetailData(selectedItem.value);
        const { data: userInfo } = await smh.userAPI.getUser({ userId: selectedItem.value.userId });
        userData.value = userInfo;
      } catch (error) {
        tips.error(error as MsgError);
      }
    };
    const methods = {
      adaptCreater(key: string, val: string, item: SMH.SpaceFileItemData) {
        if (key === 'creationPerson') {
          return optAuth('Edit', item) ? i18n_t('更新人') : i18n_t('创建人');
        }
        if (key === 'modificationTime') {
          return i18n_t('Special.过期时间');
        }
        return val;
      },
    };
    onMounted(() => {
      getLinkData();
    });
    watch(
      props,
      val => {
        getLinkData();
      },
      {
        immediate: true,
        deep: true,
      },
    );
    return {
      ...methods,
      linkDownAndPreview,
      BaseDetailType,
      DetailType,
      detailItem,
      selectedItem,
      loading,
      userData,
      getNameTipsDetail,
    };
  },
});
